

import barba from '@barba/core';

export default class{

	constructor(){

        barba.hooks.once((data) => {
            this.run()
        })
        barba.hooks.enter((data) => {
            this.run()
        });
    }
    
    run(){
        const animation_links = document.querySelectorAll('[data-hover-animation]')
        if(animation_links.length > 0){
            animation_links.forEach(link => {
                const str = link.querySelector('[data-hover-animation-target]')
                link.setAttribute('data-hover-animation',str.innerText)
            })
        }

        const buttons = document.querySelectorAll('.c-button')
        if(buttons.length > 0){
            buttons.forEach(btn => {
                btn.addEventListener("mouseleave",()=>{
                    btn.classList.add("-leave")
                    setTimeout(() => {
                        btn.classList.remove("-leave")
                    }, 300);
                })
            })
        }

        // const btn_links = document.querySelectorAll('[data-btn-links]')
        // if(btn_links.length > 0){
        //     btn_links.forEach(link => {
        //         const str = link.querySelector('[data-btn-links-str]')
        //         link.setAttribute('data-str',str.innerText)
        //     })
        // }

        // const drawer_links = document.querySelectorAll('[data-drawer-links]')
        // if(drawer_links.length > 0){
        //     drawer_links.forEach(link => {
        //         const str = link.querySelector('[data-drawer-links-str]')
        //         str.setAttribute('data-str',str.innerText)

        //         const str_en = link.querySelector('[data-drawer-links-str-en]')
        //         str_en.setAttribute('data-str-en',str_en.innerText)
        //     })
        // }
    }

}